import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {IconButton} from "@mui/material";
import {sendSocialTemplateTest} from "../../../../actions";
import {BRCustomizedTooltip as Tooltip} from "../../accents/BRCustomizedTooltip";
import BBIconSend from "../../../../assets/bbCustomIcons/BBIconSend";

const SendTestPhishingTemplate = ({templateId=null,})=>{

    const {templates, sendingTestEmail, justSentTestEmail, errorSendingTestEmail} = useSelector(({admin})=>admin);
    const template = templates && templateId && templates.templates && templates.templates[templateId];

    const dispatch= useDispatch();
    const dot = <path d="m86 50c0 19.883-16.117 36-36 36s-36-16.117-36-36 16.117-36 36-36 36 16.117 36 36"/>

    const handleSubmit = ()=> {
        console.log("Test Sent", templateId);
        dispatch(sendSocialTemplateTest(templateId));

    }



    const determineColorOrStatus =(type)=>{
        let color;
        let status;
        if(!sendingTestEmail[templateId] && !justSentTestEmail[templateId] && !errorSendingTestEmail[templateId]){
            color="#28368B"
            status="Ready To Send Test Email"
        } else if( sendingTestEmail[templateId] && !errorSendingTestEmail[templateId]){
            color="#0B154D"
            status="Sending Test Email"
        } else if(justSentTestEmail[templateId] && !errorSendingTestEmail[templateId]){
            color="#69A5FF"
            status="Test Email Just Sent"
        } else if (errorSendingTestEmail[templateId]){
            color="#5e1513"
            status="Error Sending Test Email"
        }

        return type === "color" ? color : status
    }


    return(
        <Tooltip title={determineColorOrStatus("status")}>
            <span className={"m-0 p-0 text-center"}>
            <IconButton className={"m-0 p-0 text-center"}
                        onClick={()=>handleSubmit()}>
                <BBIconSend/>
            </IconButton>
        </span>
        </Tooltip>
    )
}

export default SendTestPhishingTemplate;